<template>
 <div>
   <div v-if="!isDetailChat" class="pop-chat-index">
     <ListChat @showDetail="showDetail"></ListChat>
   </div>
   <div v-else style="height: 600px">
     <DetailChat
       @backListChat="backListChat"
       :infoDetail="infoDetail"
       :dataRight="dataRight"
     ></DetailChat>
   </div>
 </div>
</template>

<script>
  import ListChat from "@/views/chat/components/ListChat";
  import DetailChat from "@/views/chat/components/DetailChat";
  import EventBus from "@/EventBus";

  export default {
    name: "AccountRegister",
    metaInfo() {
      return {
        title: "",
      };
    },
    components: {
      ListChat,
      DetailChat,
    },
    data() {
      return {
        canSubmit: true,
        loading: true,
        isDetailChat: false,

        infoDetail: {},
        messageLast: null,
        isDataRight: false,
        dataRight: null,

      };
    },
    computed: {},
    mounted() {},
    methods: {
      showDetail (val) {
        if (val.supplier_id > 0) {
          this.isDataRight = true;
        } else {
          this.isDataRight = false;
        }
        this.isDetail = true
        this.infoDetail = val;

        // Bổ sung
        if (val.close_all) {
          this.isDetail = false
        }

        // Thêm nếu không có quyền thì cũng ẩn luôn
        /*if (this.accountInfo.id != this.infoDetail.user_id) {
          this.isDataRight = false;
        }*/

        this.isDetailChat = true;
      },
      backListChat () {
        this.isDetailChat = false;
        EventBus.$emit('zoomPopupChat', 'backDetail');
      }
    },
    watch: {},
  };
</script>

<style lang="css" scoped>
  .status_order {
    padding: 2px 5px;
    font-size: 11px;
    color: #ffffff;
    margin-left: 5px;
    border-radius: 4px;
  }
  .pop-chat-index {
    padding: 20px 10px;
    height: 570px;
  }
  .pop-chat-index .head-chat span {
    cursor: pointer;
    font-weight: 700;
  }
  .pop-chat-index .image-avatar img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    object-fit: cover;
  }
  .content-pop-chat {
    height: 450px;
    overflow-y: scroll;
    position: relative;
  }
  .content-pop-chat::-webkit-scrollbar {
    width: 8px;
  }

  .content-pop-chat::-webkit-scrollbar-track {
    border: none;
    background: transparent;
  }
  .content-pop-chat .box-item-chat {
    background: #ffffff;
    padding: 15px 10px 15px 10px;
    border-bottom: 1px solid #C4C4C440;
    cursor: pointer;
  }
  .content-pop-chat .box-item-chat:hover {
    background: #C4C4C436;
    border-radius: 5px;
  }
  .info-pop {
    width: 100%;
    font-size: 12px;
  }

  .info-pop .name {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
  }

  .info-pop .date {
    font-size: 12px;
    color: #C4C4C4;
    line-height: 16px;

  }

  .info-pop .dess {
    display: -webkit-box;
    line-height: 20px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .info-pop .number-chat {
    background: #0F56B3;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 2px 5px;
    border-radius: 4px;
    margin-left: 5px;
  }
  .box-item-order .code-po {
    padding: 2px 5px;
    background: #399CFF;
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
  }
  .isActiveBox {
    background: #C4C4C436 !important;
  }
  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
  }
</style>
